import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 16,
    marginBottom: 24
  },
  paper: {
    padding: '32px 20px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: 20
  },
  formItem: {},
  ButtonsContainer: {
    marginTop: 50,
    display: 'flex',
    flexDirection: 'row',
    gap: 0,
    justifyContent: 'flex-end',
    '& Button:first-child': {
      minHeight: 38,
      width: 116,
      fontSize: 16,
      color: `${theme.palette.grey[700]}`
    },
    '& Button:last-child': {
      minHeight: 38,
      width: 116,
      fontSize: 16,
      color: `${theme.palette.grey[200]}`
    }
  }
}))

export default useStyles
